export var AfriexTransactionStatus;
(function (AfriexTransactionStatus) {
    AfriexTransactionStatus["CANCELLED"] = "CANCELLED";
    AfriexTransactionStatus["SUCCESS"] = "SUCCESS";
    AfriexTransactionStatus["FAILED"] = "FAILED";
    AfriexTransactionStatus["PENDING"] = "PENDING";
    AfriexTransactionStatus["PROCESSING"] = "PROCESSING";
    AfriexTransactionStatus["REFUNDED"] = "REFUNDED";
    AfriexTransactionStatus["RETRY"] = "RETRY";
    AfriexTransactionStatus["UNKNOWN"] = "UNKNOWN";
    // This is a status used to identify transactions that require customer action
    // It should be used when the transaction is pending and the customer needs to take action
    // to complete the transaction
    AfriexTransactionStatus["CUSTOMER_ACTION_REQUIRED"] = "CUSTOMER_ACTION_REQUIRED";
    // Marker used server-side to identify transactions whose context is missing.
    // Not intended for other purposes; client renderers should treat it as
    // equivalent to UNKNOWN.
    AfriexTransactionStatus["UNCLEAR"] = "UNCLEAR";
    AfriexTransactionStatus["REJECTED"] = "REJECTED";
    AfriexTransactionStatus["IN_REVIEW"] = "IN_REVIEW";
    AfriexTransactionStatus["ENGINEERING_REVIEW_REQUIRED"] = "ENGINEERING_REVIEW_REQUIRED";
    // Set when a payout is placed on hold by the processor pending a request for
    // information (RFI). Non-terminal: not retried, and it does not fire a
    // terminal webhook while on hold, but it stays in the processing-poll loop so
    // a later processor-side transition is still picked up. The upfront ledger
    // debit stays in place (counted as in-transit) until it resolves. dlocal maps
    // its ON_HOLD payout status to this.
    AfriexTransactionStatus["RFI_REQUESTED"] = "RFI_REQUESTED";
    AfriexTransactionStatus["DISPUTED"] = "DISPUTED";
    AfriexTransactionStatus["DISPUTE_RESOLVED"] = "DISPUTE_RESOLVED";
    AfriexTransactionStatus["DISPUTE_WON"] = "DISPUTE_WON";
    AfriexTransactionStatus["DISPUTE_LOST"] = "DISPUTE_LOST";
    AfriexTransactionStatus["DISPUTE_EVIDENCE_SUBMITTED"] = "DISPUTE_EVIDENCE_SUBMITTED";
})(AfriexTransactionStatus || (AfriexTransactionStatus = {}));
//# sourceMappingURL=AfriexTransactionStatus.js.map